var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.image || _vm.lines)?_c('div',{class:['placeholder', { 'has-image': _vm.image && _vm.lines > 0 }]},[(_vm.image)?_c('div',{staticClass:"image"}):_vm._e(),_vm._v(" "),(_vm.lines)?_c('div',{staticClass:"text"},_vm._l((_vm.lines),function(n){return _c('div',{key:n,staticClass:"text-line"})}),0):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3209846f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Placeholder.vue
// module id = null
// module chunks = 